import { PayloadAction } from "@reduxjs/toolkit";

export function setCustomFilterGroupValueReducer(
  state,
  action: PayloadAction<{ id: string; enabled: boolean }>,
) {
  //seteamos el valor de enabled en el filterGroup, y ademas vamos a todos los hijos y deshabilitamos todas sus opciones si estamos deshabilitando el grupo.
  state.filters = state.filters.map((f) => {
    if (f.id === action.payload.id) {
      return {
        ...f,
        enabled: action.payload.enabled,
      };
    }
    return f;
  });
}
